module.exports = __webpack_public_path__ + "img/logo-small.2dc608a9.png";